import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import WarningIcon from '@material-ui/icons/ReportProblem';

import Modal from '../Modal';
import useStyles from './useStyles';

const DetectStorage = ({
  message, subMessage, allowBrowsers,
}) => {
  const [showModal, setShowModal] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    if (!window?.localStorage && !window?.sessionStorage && !window.indexedDB) setShowModal(true);
  }, []);

  return (
    <Modal
      showModal={showModal}
      setShowModal={() => setShowModal(false)}
    >
      <div className={classes.container}>
        <WarningIcon className={classes.icon} />
        <p className={classes.message}>{message}</p>
        { subMessage && <p className={classes.subMessage}>{subMessage}</p>}
        { allowBrowsers.length
            && <p className={classes.allowBrowser}>{allowBrowsers.map((allorBrowser) => `- ${allorBrowser} `)}</p>}
      </div>
    </Modal>
  );
};

DetectStorage.propTypes = {
  message: PropTypes.string.isRequired,
  subMessage: PropTypes.string,
  allowBrowsers: PropTypes.arrayOf(PropTypes.string),
};

DetectStorage.defaultProps = {
  subMessage: '',
  allowBrowsers: [],
};

export default DetectStorage;
